module.exports = __webpack_public_path__ + "img/banner_tjx_jwjc.bc1c341d.jpg";